import { z } from "zod";
import { firestoreTimestampSchema } from "./common.schema";
import { companyContractSchema } from "./contract.schema";

// ============================================
// COMPANY ENTITY SCHEMA
// ============================================

export const companySchema = z.object({
  id: z.string().optional(),
  name: z.string().min(1, "Company name is required"),
  searchName: z.string(), // Lowercase for autocomplete
  address: z.string().optional(),
  vatNumber: z.string().optional(),
  taxCode: z.string().optional(),
  legalRepresentativeName: z.string().optional(),
  primaryDoctorId: z.string().optional(), // Main doctor for the company
  coordinationDoctorIds: z.array(z.string()).optional(), // Coordination doctors
  geslabId: z.string().optional(),
  pec: z.string().optional(),
  sdiCode: z.string().optional(),
  createdAt: firestoreTimestampSchema.optional(),
  updatedAt: firestoreTimestampSchema.optional(),
  email: z.string().email().optional(),
  phone: z.string().optional(),
  debt: z.boolean().optional(),
  contract: companyContractSchema.optional(),
});

export type Company = z.infer<typeof companySchema>;

// ============================================
// CREATE COMPANY DTO
// ============================================

export const createCompanySchema = z.object({
  name: z.string().min(1, "Company name is required"),
  address: z.string().optional(),
  vatNumber: z.string().optional(),
  taxCode: z.string().optional(),
  legalRepresentativeName: z.string().optional(),
  primaryDoctorId: z.string().optional(),
  coordinationDoctorIds: z.array(z.string()).optional(),
  geslabId: z.string().optional(),
  email: z.string().optional(),
  phone: z.string().optional(),
  debt: z.boolean().optional(),
});

export type CreateCompany = z.infer<typeof createCompanySchema>;

// ============================================
// UPDATE COMPANY DTO
// ============================================

export const updateCompanySchema = createCompanySchema.partial();

export type UpdateCompany = z.infer<typeof updateCompanySchema>;

// ============================================
// UTILITY FUNCTION
// ============================================

export function createCompanySearchName(name: string): string {
  return name.toLowerCase();
}
